import React from 'react'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import { Card } from 'material-ui/Card'
import FontIcon from 'material-ui/FontIcon'
import FixedImg from './FixedImg'
import { Row, Col } from 'pui-react-grids'
import RaisedButton from 'material-ui/RaisedButton'
import { themeColors } from '../styles/theme'
import { getObjectOwner, getObjectCondition, getImmaginiOfUser } from '../utils'
import Chip from 'material-ui/Chip'
import { AFFIDABILITA_ICON_NAME } from '../styles/icons'
import ItemOwnersTable from './ItemOwnersTable'

const iconStyles = {
  fontSize: '20px',
  position: 'relative',
  top: '4px',
}

const styles = {
  chip: {
    marginLeft: 'auto',
    height: 32,
    border: '1px solid #00b4bc',
  },
  button: {
    marginRight: 10,
    marginTop: 10,
    width: 210,
  },
  ImageInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
  containerStyle: {
    marginBottom: 10,
    padding: 10,
  },
  titleStyle: {
    marginBottom: '10px',
    paddingLeft: 0,
    fontWeight: 'bold',
    paddingBottom: 0,
    fontSize: 24,
    lineHeight: '36px',
    color: 'rgb(0, 180, 188)',
  },
  ColRightStyle: {
    padding: '20px',
  },
  DetailCategoryStyle: {
    fontWeight: 'bold',
    color: '#C4C4C4',
    marginBottom: '20px',
  },
  DetailSecondaryActionsBtns: {
    marginBottom: 30,
  },
  DetailDescrizione: {
    fontWeight: 'bold',
    paddingTop: '5px',
    paddingRight: 20,
  },
  DetailValore: {
    paddingTop: '5px',
    paddingLeft: '15px',
    whiteSpace: 'pre-line',
    wordBreak: 'break-word',
  },
  viewedImage: {
    border: `2px solid ${themeColors.positive}`,
    cursor: 'pointer',
  },
  previewImage: {
    cursor: 'pointer',
  },
  userLinkStyle: {
    color: themeColors.positive,
    ':visited': {
      color: themeColors.positive,
    },
  },
}

const SecondaryBtn = {
  text: {
    textTransform: 'none',
    fontSize: 12,
    top: '-1px',
  },
}

const ObjectDetail = ({
  item,
  owner,
  user = null,
  canSwap = false,
  canSwapLoading = false,
  canProposeSwap = false,
  canProposeSwapLoading = false,
  showDeleteInterest = false,
  deletingInterest = false,
  viewedImage,
  setViewedImage,
  wantedLoading,
  iWant,
  iWantNot,
  onOwnedClick,
  onNotOwnedClick,
  onEditClick,
  onBuyClick,
  onSwapClick,
  removeInterestClick,
}) => {
  // Is object owned by current logged user?
  const owned = user ? getObjectOwner(item, user.id) : undefined
  const altreImmagini = owner
    ? getImmaginiOfUser(item.altre_immagini, owner.user.id)
    : []

  return (
    <div className="padding padding-no-top">
      <Card containerStyle={styles.containerStyle}>
        <Row>
          <Col md={12} sm={12} xs={24} style={{ textAlign: 'center' }}>
            <div>
              <div style={{ margin: 10 }}>
                <FixedImg
                  src={viewedImage || item.immagine}
                  height={350}
                  resolution="large"
                />
              </div>
              <Row>
                {altreImmagini.length > 0 && (
                  <Col md={6} sm={8} xs={8}>
                    <div style={{ margin: 5 }}>
                      <FixedImg
                        resolution="small"
                        src={item.immagine}
                        height={80}
                        onClick={() => setViewedImage(item.immagine)}
                        imgStyle={
                          viewedImage === item.immagine
                            ? styles.viewedImage
                            : styles.previewImage
                        }
                      />
                    </div>
                  </Col>
                )}
                {altreImmagini.map(immagine => (
                  <Col md={6} sm={8} xs={8} key={immagine.percorso}>
                    <div style={{ margin: 5 }}>
                      <FixedImg
                        src={immagine.percorso}
                        resolution="small"
                        height={80}
                        onClick={() => setViewedImage(immagine.percorso)}
                        imgStyle={
                          viewedImage === immagine.percorso
                            ? styles.viewedImage
                            : styles.previewImage
                        }
                      />
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
          <Col md={12} sm={12} xs={24} style={styles.ColRightStyle}>
            <h1 style={styles.titleStyle}>{item.titolo}</h1>
            <div style={{ display: 'flex' }}>
              <span style={styles.DetailCategoryStyle}>
                {item.categoria.nome}{' '}
                {item.genere && <span>/ {item.genere}</span>}
              </span>

              {owner &&
                owner.valore && (
                  <Chip
                    style={styles.chip}
                    backgroundColor={themeColors.white}
                    labelColor={themeColors.positive}
                    className="marginright-for-big">
                    € {owner.valore}
                  </Chip>
                )}
            </div>

            <table style={{ marginBottom: 20 }}>
              <tbody>
                {get(item, 'attributi', []).map(attributo => (
                  <tr key={attributo.descrizione}>
                    <td style={styles.DetailDescrizione}>
                      {attributo.descrizione}
                    </td>
                    <td style={styles.DetailValore}>{attributo.valore}</td>
                  </tr>
                ))}

                {owner && (
                  <tr>
                    <td style={styles.DetailDescrizione}>
                      {item.categoria.id === 50
                        ? 'Condizioni Disco'
                        : 'Condizioni'}
                    </td>
                    <td style={styles.DetailValore}>
                      {getObjectCondition(item.categoria.id, owner.condizioni)}
                    </td>
                  </tr>
                )}

                {owner &&
                  item.categoria.id === 50 && (
                    <tr>
                      <td style={styles.DetailDescrizione}>
                        Condizioni Copertina
                      </td>
                      <td style={styles.DetailValore}>
                        {getObjectCondition(
                          item.categoria.id,
                          owner.condizioni2
                        )}
                      </td>
                    </tr>
                  )}
              </tbody>
            </table>

            {owner && <p className="pre">{owner.note}</p>}

            {item.interesse &&
              item.interesse_note && (
                <p className="pre">{item.interesse_note}</p>
              )}

            {owner && (
              <div
                style={{ fontSize: '14px' }}
                className="ObjectDetail_OwnerContainer">
                <div>
                  <FontIcon className="material-icons" style={iconStyles}>
                    person
                  </FontIcon>
                  {' di '}
                  <Link
                    style={styles.userLinkStyle}
                    to={`/user/${owner.user.username}`}>
                    <strong>{owner.user.username}</strong>
                  </Link>
                </div>
                <span>
                  <FontIcon className="material-icons" style={iconStyles}>
                    cached
                  </FontIcon>{' '}
                  {owner.user.transazioni} transazioni concluse
                </span>
                <span style={{ paddingLeft: '20px' }}>
                  <FontIcon className="material-icons" style={iconStyles}>
                    {AFFIDABILITA_ICON_NAME}
                  </FontIcon>{' '}
                  {owner.user.transazioni > 3
                    ? `${Number(owner.user.affidabilita * 100).toFixed()}%`
                    : '-'}
                </span>
                <div>
                  <FontIcon className="material-icons" style={iconStyles}>
                    place
                  </FontIcon>{' '}
                  {owner.user.district}
                </div>
                <br />
              </div>
            )}

            {/* Only logged user can see buttons */}
            {user &&
              !item.interesse && (
                <div className="textcenter-for-small">
                  {/*
                  Lo possego ma sta guardando l'oggetto di un altro tipo
                  o il dettaglio generico con lista possesori
                */}
                  {owned &&
                    (!owner || user.id !== owner.user.id) && (
                      <div>
                        <RaisedButton
                          label="Vai al tuo"
                          primary={true}
                          containerElement={
                            <Link to={`/item/${item.id}?userId=${user.id}`} />
                          }
                          style={styles.button}
                          className="LoPossiedoBtn"
                        />
                      </div>
                    )}

                  {/*
                  Lo possego e sto guardando il mio
                */}
                  {owned &&
                    owner &&
                    user.id === owner.user.id && (
                      <div className="column">
                        <RaisedButton
                          label="Non lo possiedo più"
                          disabled={!!item.impegnato}
                          primary={true}
                          style={styles.button}
                          className="LoPossiedoBtn"
                          onClick={onNotOwnedClick}
                        />
                        <RaisedButton
                          label="Modifica"
                          onClick={onEditClick}
                          primary={true}
                          style={styles.button}
                          className="LoPossiedoBtn"
                        />
                        <RaisedButton
                          containerElement={
                            <Link to={`/me/items/can-get?item=${item.id}`} />
                          }
                          disabled={!canSwap || canSwapLoading}
                          className={
                            !canSwap || canSwapLoading
                              ? 'no-pointer-events'
                              : undefined
                          }
                          label="Scambia"
                          secondary={true}
                          style={styles.button}
                        />
                      </div>
                    )}

                  {/* Non lo possiedo */}
                  {!owned && (
                    <div className="column">
                      <RaisedButton
                        label={!item.voluto ? 'Lo voglio' : 'Non lo voglio più'}
                        primary={true}
                        disabled={wantedLoading}
                        onClick={() =>
                          item.voluto ? iWantNot(item) : iWant(item)
                        }
                        style={styles.button}
                        className="LoVoglioBtn"
                      />
                      <RaisedButton
                        label="Lo Possiedo"
                        primary={true}
                        style={styles.button}
                        className="LoPossiedoBtn"
                        onClick={onOwnedClick}
                      />
                    </div>
                  )}

                  {/* Non lo possiedo ma qualcuno lo possiede */}
                  {!owned &&
                    owner && (
                      <div>
                        <div className="column">
                          <RaisedButton
                            label="Compra"
                            onClick={onBuyClick}
                            secondary={true}
                            style={styles.button}
                          />
                          <RaisedButton
                            onClick={onSwapClick}
                            disabled={!canProposeSwap || canProposeSwapLoading}
                            className={
                              !canProposeSwap || canProposeSwapLoading
                                ? 'no-pointer-events'
                                : undefined
                            }
                            label="Scambia"
                            secondary={true}
                            style={styles.button}
                          />
                        </div>
                      </div>
                    )}
                </div>
              )}

            {/* Bottone cancellazione interesse */}
            {user &&
              item.interesse &&
              showDeleteInterest && (
                <div className="textcenter-for-small">
                  <RaisedButton
                    label="Non mi interessa più"
                    disabled={deletingInterest}
                    onClick={removeInterestClick}
                    primary={true}
                    style={styles.button}
                    className="LoPossiedoBtn"
                  />
                </div>
              )}

            <div className="column">
              <div style={styles.DetailSecondaryActionsBtns}>
                {item.amazon && (
                  <RaisedButton
                    label="Compra su Amazon"
                    href={item.amazon}
                    target="_blank"
                    style={styles.button}
                    labelStyle={SecondaryBtn.text}
                    backgroundColor={themeColors.amazon}
                    icon={<FontIcon className="fa fa-amazon" />}
                  />
                )}
              </div>
            </div>
          </Col>
        </Row>

        {/* Mostra la lista dei possesori */}
        {!owner &&
          item.posseduto_da.length > 0 && (
            <div style={{ padding: 20 }}>
              <ItemOwnersTable item={item} />
            </div>
          )}
      </Card>
    </div>
  )
}

export default ObjectDetail



// WEBPACK FOOTER //
// ./src/common/ObjectDetail.js